// extracted by mini-css-extract-plugin
export default {"addsep_header":"AddSepultado_addsep_header__fRXQ1"};